import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {deleto, get, post, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";

// Create asset type
export function* createAssetTypeRequest() {
    yield takeEvery(actions.ASSET_TYPE_CREATE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(post, '/assets/types', request, context);

            // OK
            yield put({
                type: actions.ASSET_TYPE_CREATE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_TYPE_CREATE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createAssetTypeSuccess() {
    yield takeEvery(actions.ASSET_TYPE_CREATE_SUCCESS, function* () {
        yield message.success(t`The asset type is created.`);
    });
}
export function* createAssetTypeFail() {
    yield takeEvery(actions.ASSET_TYPE_CREATE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read asset types
export function* readAssetTypeListRequest() {
    yield takeEvery(actions.ASSET_TYPE_READ_LIST_REQUEST, function* ({ request}, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/assets/types', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.ASSET_TYPE_READ_LIST_SUCCESS,
                assetTypes: data.asset_types,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_TYPE_READ_LIST_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readAssetTypeListSuccess() {
    yield takeEvery(actions.ASSET_TYPE_READ_LIST_SUCCESS, () => {});
}
export function* readAssetTypeListFail() {
    yield takeEvery(actions.ASSET_TYPE_READ_LIST_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read asset type
export function* readAssetTypeRequest() {
    yield takeEvery(actions.ASSET_TYPE_READ_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/assets/types/${id}`, null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.ASSET_TYPE_READ_SUCCESS,
                assetType: data.asset_type,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_TYPE_READ_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readAssetTypeSuccess() {
    yield takeEvery(actions.ASSET_TYPE_READ_SUCCESS, () => {});
}
export function* readAssetTypeFail() {
    yield takeEvery(actions.ASSET_TYPE_READ_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update asset type
export function* updateAssetTypeRequest() {
    yield takeEvery(actions.ASSET_TYPE_UPDATE_REQUEST, function* ({ id, request }, context) {
        try {
            context.allow_intercept = true;
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, `/assets/types/${id}`, request, context);

            // OK
            yield put({
                type: actions.ASSET_TYPE_UPDATE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_TYPE_UPDATE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateAssetTypeSuccess() {
    yield takeEvery(actions.ASSET_TYPE_UPDATE_SUCCESS, function* () {
        yield message.success(t`The asset type is updated.`);
    });
}
export function* updateAssetTypeFail() {
    yield takeEvery(actions.ASSET_TYPE_UPDATE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete asset type
export function* deleteAssetTypeRequest() {
    yield takeEvery(actions.ASSET_TYPE_DELETE_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/assets/types/${id}`, null, context);

            // OK
            yield put({
                type: actions.ASSET_TYPE_DELETE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_TYPE_DELETE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteAssetTypeSuccess() {
    yield takeEvery(actions.ASSET_TYPE_DELETE_SUCCESS, function* () {
        yield message.success(t`The asset type is deleted.`);
    });
}
export function* deleteAssetTypeFail() {
    yield takeEvery(actions.ASSET_TYPE_DELETE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read purchases
export function* readPurchaseListRequest() {
    yield takeEvery(actions.ASSET_READ_PURCHASE_LIST_REQUEST, function* (payload, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/assets/purchases', null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.ASSET_READ_PURCHASE_LIST_SUCCESS,
                purchases: data.transactions,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_READ_PURCHASE_LIST_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readPurchaseListSuccess() {
    yield takeEvery(actions.ASSET_READ_PURCHASE_LIST_SUCCESS, () => {});
}
export function* readPurchaseListFail() {
    yield takeEvery(actions.ASSET_READ_PURCHASE_LIST_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read asset depreciation dates
export function* readAssetDepreciationDateListRequest() {
    yield takeEvery(actions.ASSET_DEPRECIATION_READ_DATE_LIST_REQUEST, function* (payload, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/assets/depreciations/dates', null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.ASSET_DEPRECIATION_READ_DATE_LIST_SUCCESS,
                depreciationDates: data.dates,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_DEPRECIATION_READ_DATE_LIST_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readAssetDepreciationDateListSuccess() {
    yield takeEvery(actions.ASSET_DEPRECIATION_READ_DATE_LIST_SUCCESS, () => {});
}
export function* readAssetDepreciationDateListError() {
    yield takeEvery(actions.ASSET_DEPRECIATION_READ_DATE_LIST_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Preview asset depreciation
export function* previewAssetDepreciationRequest() {
    yield takeEvery(actions.ASSET_DEPRECIATION_PREVIEW_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/assets/depreciations/preview', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.ASSET_DEPRECIATION_PREVIEW_SUCCESS,
                previewDepreciations: data.assets,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_DEPRECIATION_PREVIEW_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* previewAssetDepreciationSuccess() {
    yield takeEvery(actions.ASSET_DEPRECIATION_PREVIEW_SUCCESS, () => {});
}
export function* previewAssetDepreciationError() {
    yield takeEvery(actions.ASSET_DEPRECIATION_PREVIEW_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Create asset depreciation
export function* createAssetDepreciationRequest() {
    yield takeEvery(actions.ASSET_DEPRECIATION_CREATE_REQUEST, function* ({ request }, context) {
        try {
            context.allow_intercept = true;
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(post, '/assets/depreciations', request, context);

            // OK
            yield put({
                type: actions.ASSET_DEPRECIATION_CREATE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_DEPRECIATION_CREATE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createAssetDepreciationSuccess() {
    yield takeEvery(actions.ASSET_DEPRECIATION_CREATE_SUCCESS, function* () {
        yield message.success(t`The depreciations have been created.`);
    });
}
export function* createAssetDepreciationError() {
    yield takeEvery(actions.ASSET_DEPRECIATION_CREATE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete asset depreciation list
export function* deleteAssetDepreciationListRequest() {
    yield takeEvery(actions.ASSET_DEPRECIATION_DELETE_LIST_REQUEST, function* ({ request }, context) {
        try {
            context.allow_intercept = true;
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, '/assets/depreciations', request, context);

            // OK
            yield put({
                type: actions.ASSET_DEPRECIATION_DELETE_LIST_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_DEPRECIATION_DELETE_LIST_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteAssetDepreciationListSuccess() {
    yield takeEvery(actions.ASSET_DEPRECIATION_DELETE_LIST_SUCCESS, function* () {
        yield message.success(t`The depreciations have been rolled back.`);
    });
}
export function* deleteAssetDepreciationListError() {
    yield takeEvery(actions.ASSET_DEPRECIATION_DELETE_LIST_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Create asset
export function* createAssetRequest() {
    yield takeEvery(actions.ASSET_CREATE_REQUEST, function* ({ request }, context) {
        try {
            context.allow_intercept = true;
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(post, '/assets', request, context);

            // OK
            yield put({
                type: actions.ASSET_CREATE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_CREATE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createAssetSuccess() {
    yield takeEvery(actions.ASSET_CREATE_SUCCESS, function* () {
        yield message.success(t`The asset is registered.`);
    });
}
export function* createAssetError() {
    yield takeEvery(actions.ASSET_CREATE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Create asset
export function* createBulkCreateRequest() {
    yield takeEvery(actions.ASSET_BULK_CREATE_REQUEST, function* ({ request }, context) {
        try {
            context.allow_intercept = true;

            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(post, '/assets/bulk', request, context);

            // OK
            yield put({
                type: actions.ASSET_BULK_CREATE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_BULK_CREATE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createBulkCreateSuccess() {
    yield takeEvery(actions.ASSET_BULK_CREATE_SUCCESS, function* () {
        yield message.success(t`All assets are registered.`);
    });
}
export function* createBulkCreateError() {
    yield takeEvery(actions.ASSET_BULK_CREATE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read asset list
export function* readAssetListRequest() {
    yield takeEvery(actions.ASSET_READ_LIST_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });

            const response = yield call(get, '/assets', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.ASSET_READ_LIST_SUCCESS,
                assets: data.assets,
                pagination: data.paging,
                lastDepreciated: data.last_depreciated,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_READ_LIST_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readAssetListSuccess() {
    yield takeEvery(actions.ASSET_READ_LIST_SUCCESS, () => {});
}
export function* readAssetListError() {
    yield takeEvery(actions.ASSET_READ_LIST_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read asset
export function* readAssetRequest() {
    yield takeEvery(actions.ASSET_READ_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/assets/${id}`, null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.ASSET_READ_SUCCESS,
                asset: data.asset,
                depreciations: data.depreciations,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_READ_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readAssetSuccess() {
    yield takeEvery(actions.ASSET_READ_SUCCESS, () => {});
}
export function* readAssetError() {
    yield takeEvery(actions.ASSET_READ_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update asset
export function* updateAssetRequest() {
    yield takeEvery(actions.ASSET_UPDATE_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            context.allow_intercept = true;
            yield call(puto, `/assets/${id}`, request, context);

            // OK
            yield put({
                type: actions.ASSET_UPDATE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_UPDATE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateAssetSuccess() {
    yield takeEvery(actions.ASSET_UPDATE_SUCCESS, function* () {
        yield message.success(t`The asset has been updated.`);
    });
}
export function* updateAssetError() {
    yield takeEvery(actions.ASSET_UPDATE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete asset
export function* deleteAssetRequest() {
    yield takeEvery(actions.ASSET_DELETE_REQUEST, function* ({ id, period_lock_passcode }, context) {
        try {
            context.allow_intercept = true;
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/assets/${id}`, { period_lock_passcode }, context);

            // OK
            yield put({
                type: actions.ASSET_DELETE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_DELETE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteAssetSuccess() {
    yield takeEvery(actions.ASSET_DELETE_SUCCESS, function* () {
        yield message.success(t`The asset has been deleted.`);
    });
}
export function* deleteAssetError() {
    yield takeEvery(actions.ASSET_DELETE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Dispose asset
export function* disposeAssetRequest() {
    yield takeEvery(actions.ASSET_DISPOSE_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            context.allow_intercept = true;
            yield call(post, `/assets/${id}/dispose`, request, context);

            // OK
            yield put({
                type: actions.ASSET_DISPOSE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_DISPOSE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* disposeAssetSuccess() {
    yield takeEvery(actions.ASSET_DISPOSE_SUCCESS, function* () {
        yield message.success(t`The asset has been disposed.`);
    });
}
export function* disposeAssetError() {
    yield takeEvery(actions.ASSET_DISPOSE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Undispose asset
export function* undisposeAssetRequest() {
    yield takeEvery(actions.ASSET_UNDISPOSE_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            context.allow_intercept = true;
            yield call(post, `/assets/${id}/undispose`, request, context);

            // OK
            yield put({
                type: actions.ASSET_UNDISPOSE_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ASSET_UNDISPOSE_FAIL,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* undisposeAssetSuccess() {
    yield takeEvery(actions.ASSET_UNDISPOSE_SUCCESS, function* () {
        yield message.success(t`The asset has been restored.`);
    });
}
export function* undisposeAssetError() {
    yield takeEvery(actions.ASSET_UNDISPOSE_FAIL, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(createAssetTypeRequest),
        fork(createAssetTypeSuccess),
        fork(createAssetTypeFail),
        fork(readAssetTypeListRequest),
        fork(readAssetTypeListSuccess),
        fork(readAssetTypeListFail),
        fork(readAssetTypeRequest),
        fork(readAssetTypeSuccess),
        fork(readAssetTypeFail),
        fork(updateAssetTypeRequest),
        fork(updateAssetTypeSuccess),
        fork(updateAssetTypeFail),
        fork(deleteAssetTypeRequest),
        fork(deleteAssetTypeSuccess),
        fork(deleteAssetTypeFail),
        fork(readPurchaseListRequest),
        fork(readPurchaseListSuccess),
        fork(readPurchaseListFail),
        fork(readAssetDepreciationDateListRequest),
        fork(readAssetDepreciationDateListSuccess),
        fork(readAssetDepreciationDateListError),
        fork(previewAssetDepreciationRequest),
        fork(previewAssetDepreciationSuccess),
        fork(previewAssetDepreciationError),
        fork(createAssetDepreciationRequest),
        fork(createAssetDepreciationSuccess),
        fork(createAssetDepreciationError),
        fork(deleteAssetDepreciationListRequest),
        fork(deleteAssetDepreciationListSuccess),
        fork(deleteAssetDepreciationListError),
        fork(createAssetRequest),
        fork(createAssetSuccess),
        fork(createAssetError),
        fork(readAssetListRequest),
        fork(readAssetListSuccess),
        fork(readAssetListError),
        fork(readAssetRequest),
        fork(readAssetSuccess),
        fork(readAssetError),
        fork(updateAssetRequest),
        fork(updateAssetSuccess),
        fork(updateAssetError),
        fork(deleteAssetRequest),
        fork(deleteAssetSuccess),
        fork(deleteAssetError),
        fork(disposeAssetRequest),
        fork(disposeAssetSuccess),
        fork(disposeAssetError),
        fork(undisposeAssetRequest),
        fork(undisposeAssetSuccess),
        fork(undisposeAssetError),
        fork(createBulkCreateRequest),
        fork(createBulkCreateSuccess),
        fork(createBulkCreateError),
    ]);
}
